"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithFeatureContext = exports.useFeatureContext = exports.createTFunc = exports.parseTextConfig = void 0;
const react_1 = __importStar(require("react"));
const AppContext_1 = require("./AppContext");
const ErrorBoundary_1 = require("./ErrorBoundary");
const parseTextConfig = (textConfig, parse) => {
    return textConfig.replace(/\{\{(.*?)\}\}/g, (match, key) => parse[key]);
};
exports.parseTextConfig = parseTextConfig;
const createTFunc = (textConfig, rootT) => {
    return (textName, parse) => {
        const key = textName;
        let text = textConfig[key] || '';
        if (parse) {
            text = (0, exports.parseTextConfig)(text, parse);
        }
        if (!text && rootT) {
            try {
                return rootT(textName, parse) || '';
            }
            catch (_a) { }
        }
        return text;
    };
};
exports.createTFunc = createTFunc;
const ReactFeatureContext = react_1.default.createContext({
    t: () => '',
    getProxy: () => undefined
});
const useFeatureContext = () => {
    return (0, react_1.useContext)(ReactFeatureContext);
};
exports.useFeatureContext = useFeatureContext;
const WithFeatureContext = (component, textsConfig, proxiesConfig) => {
    return (props) => {
        const { t, getProxy } = (0, exports.useFeatureContext)();
        const appContext = (0, react_1.useContext)(AppContext_1.AppContext);
        return react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null, react_1.default.createElement(ReactFeatureContext.Provider, {
            value: {
                t: (0, exports.createTFunc)(textsConfig, t),
                getProxy: (proxyName) => {
                    let proxy = proxiesConfig ? proxiesConfig[proxyName] : null;
                    if (!proxy) {
                        try {
                            proxy = getProxy(proxyName);
                        }
                        catch (_a) { }
                    }
                    if (!proxy) {
                        throw new Error(`WithFeatureContext error: proxy "${proxyName}" not provided`);
                    }
                    if (proxy && appContext && typeof proxy.setContext === 'function') {
                        proxy.setContext(appContext.getApiRequest());
                    }
                    return proxy;
                }
            }
        }, react_1.default.createElement(component, props)));
    };
};
exports.WithFeatureContext = WithFeatureContext;
//# sourceMappingURL=FeatureContext.js.map